import request from '@/utils/request'

export function registerVendor(data) {
    return request({
        url: '/vendor/register',
        method: 'post',
        data: data
    })
}

export function getInfo(id) {
    return request({
        url: '/vendor/' + id,
        method: 'get',
    })
}

export function fetchList(params) {
    return request({
        url: '/vendor/list',
        method: 'get',
        params: params
    })
}

export function updateVendor(id, data) {
    return request({
        url: '/vendor/update/' + id,
        method: 'post',
        data: data
    })
}

export function updateStatus(id, params) {
    return request({
        url: '/vendor/updateStatus/' + id,
        method: 'post',
        params: params
    })
}

export function deleteVendor(id) {
    return request({
        url: '/vendor/delete/' + id,
        method: 'post',
    })
}